const translations = {
  es: {
    nav: { home: "Inicio", contact: "Contacto", simulator: "Entrar al simulador" },
    hero: {
      tagline: "Dirige tu hospital: Lleva la salud a su máximo nivel con MedSim",
      h1_line1: "Dirige un Hospital.",
      h1_line2: "Domina la Estrategia.",
      subtitle: "La simulación de gestión hospitalaria más inmersiva para desarrollar habilidades estratégicas en el mundo real.",
      cta_primary: "Explorar la plataforma",
      cta_video: "Ver video",
    },
    lab: {
      h2: "Toma decisiones estratégicas con datos reales",
      text: "MedSim simula un entorno competitivo donde asumes el rol de CEO. Gestiona finanzas, operaciones y marketing mientras controlas tus KPIs reales. Todo con el rigor académico y las decisiones que tienen consecuencias en tus resultados.",
    },
    features: {
      h2: "Decisiones que marcan la diferencia",
      intro: "Dirigir no es solo elegir. Enfrentarse a MedSim significa gestionar la complejidad de una organización real en sus pilares fundamentales: Gestión de personal, Estrategia Competitiva, Operaciones y Logística, Gestión del Talento y Salud Financiera.",
      cards: [
        { title: "Simulación hospitalaria estratégica", desc: "Gestiona operaciones, finanzas y marketing de un hospital en competencia directa con otros CEOs. Cada decisión tiene consecuencias reales." },
        { title: "KPIs reales y métricas financieras", desc: "Siente el pulso del mercado: Sigue la evolución del precio de tu acción y tus ganancias netas al segundo." },
        { title: "Toma de decisiones bajo presión con IA integrada", desc: "Tu copiloto estratégico: El Asesor de IA integrado optimiza tu toma de decisiones." },
        { title: "Laboratorio de gestión académico", desc: "MedSim no es un juego, es un entorno riguroso de aprendizaje. Diseñado para programas de formación de ejecutivos." },
        { title: "Análisis y retroalimentación inmediata", desc: "Visualiza cómo cada decisión estratégica impacta en el resultado financiero." },
        { title: "Entorno competitivo colaborativo", desc: "Compite contra otros equipos en tiempo real mientras aprendes de sus estrategias." },
      ],
    },
    testimonials: {
      h2: "Lo que dicen los expertos",
      items: [
        { quote: "MedSim ha transformado cómo enseño gestión estratégica. Los estudiantes experimentan decisiones reales bajo presión, comprendiendo en semanas lo que normalmente tomaría un semestre.", author: "Profesor Gustavo Bautista", role: "PROFESOR DE ESTRATEGIA, UNIVERSIDAD COMPLUTENSE DE MADRID" },
        { quote: "La plataforma proporciona rigor académico sin sacrificar el engagement. Los KPIs reales mantienen a los estudiantes enfocados en decisiones estratégicas coherentes, no en ganar a cualquier costo.", author: "Soraya Gómez", role: "PROFESORA DE FORMACIÓN PROFESIONAL" },
        { quote: "Implementamos MedSim en tres programas. El feedback de estudiantes confirma que es el laboratorio de gestión más efectivo que hemos usado. Entienden el flujo de caja, la estrategia y el riesgo de verdad.", author: "Daniel Arias Aranda", role: "CATEDRÁTICO DE ORGANIZACIÓN DE EMPRESAS, UNIVERSIDAD DE GRANADA" },
        { quote: "MedSim no es un juego. Es un espacio donde los estudiantes piensan como CEOs. Ven cómo sus decisiones en operaciones impactan finanzas, cómo el marketing afecta el precio de acción. Ese aprendizaje integrado es invaluable.", author: "Cristina García Valverde", role: "EJECUTIVA DE CUENTAS" },
      ],
    },
    metrics: {
      items: [
        { value: 95, label: "Gestión de Crisis y Resiliencia" },
        { value: 92, label: "Visión estratégica integrada" },
        { value: 98, label: "Retención de conocimiento" },
        { value: 89, label: "Mejora en toma de decisiones" },
      ],
    },
    cta: {
      h2: "Lleva el aprendizaje de gestión al siguiente nivel",
      text: "Descubre cómo MedSim transforma la educación ejecutiva. Contacta con nosotros para una demostración personalizada.",
      button: "Solicitar demostración",
    },
    contact: {
      h2: "Contacto",
      name: "Nombre",
      email: "Correo electrónico",
      message: "Mensaje",
      submit: "Enviar mensaje",
      success: "Mensaje enviado correctamente",
      error: "Error al enviar el mensaje",
      info: "También puedes escribirnos a",
      consent: "He leído y acepto la",
      consent_link: "Política de Privacidad",
      consent_required: "Debe aceptar la Política de Privacidad para enviar el mensaje",
    },
    cookie: {
      text: "Este sitio web utiliza cookies para mejorar su experiencia. Al continuar navegando, acepta el uso de cookies conforme a nuestra política de privacidad.",
      accept: "Aceptar",
      reject: "Rechazar",
    },
    footer: {
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      legal: "Aviso Legal",
      cookies: "Política de Cookies",
      accessibility: "Accesibilidad",
      rights: "Todos los derechos reservados.",
    },
    privacy: { title: "Política de Privacidad" },
    terms: { title: "Términos de Servicio" },
  },
  en: {
    nav: { home: "Home", contact: "Contact", simulator: "Enter simulator" },
    hero: {
      tagline: "Run your hospital: Take healthcare to the highest level with MedSim",
      h1_line1: "Run a Hospital.",
      h1_line2: "Master the Strategy.",
      subtitle: "The most immersive hospital management simulation to develop strategic skills in the real world.",
      cta_primary: "Explore the platform",
      cta_video: "Watch video",
    },
    lab: {
      h2: "Make strategic decisions with real data",
      text: "MedSim simulates a competitive environment where you take on the role of CEO. Manage finances, operations, and marketing while tracking your real KPIs. All with academic rigor and decisions that have real consequences on your results.",
    },
    features: {
      h2: "Decisions that make a difference",
      intro: "Leading is not just choosing. Facing MedSim means managing the complexity of a real organization in its fundamental pillars: Personnel Management, Competitive Strategy, Operations and Logistics, Talent Management and Financial Health.",
      cards: [
        { title: "Strategic hospital simulation", desc: "Manage operations, finances, and marketing of a hospital in direct competition with other CEOs. Every decision has real consequences." },
        { title: "Real KPIs and financial metrics", desc: "Feel the pulse of the market: Follow the evolution of your stock price and net earnings in real time." },
        { title: "Decision-making under pressure with integrated AI", desc: "Your strategic copilot: The integrated AI Advisor optimizes your decision-making." },
        { title: "Academic management laboratory", desc: "MedSim is not a game, it is a rigorous learning environment. Designed for executive training programs." },
        { title: "Immediate analysis and feedback", desc: "Visualize how each strategic decision impacts the financial result." },
        { title: "Collaborative competitive environment", desc: "Compete against other teams in real time while learning from their strategies." },
      ],
    },
    testimonials: {
      h2: "What the experts say",
      items: [
        { quote: "MedSim has transformed how I teach strategic management. Students experience real decisions under pressure, understanding in weeks what would normally take a semester.", author: "Professor Gustavo Bautista", role: "STRATEGY PROFESSOR, COMPLUTENSE UNIVERSITY OF MADRID" },
        { quote: "The platform provides academic rigor without sacrificing engagement. Real KPIs keep students focused on coherent strategic decisions, not winning at any cost.", author: "Soraya Gómez", role: "VOCATIONAL TRAINING PROFESSOR" },
        { quote: "We implemented MedSim in three programs. Student feedback confirms it is the most effective management laboratory we have used. They truly understand cash flow, strategy, and risk.", author: "Daniel Arias Aranda", role: "PROFESSOR OF BUSINESS ORGANIZATION, UNIVERSITY OF GRANADA" },
        { quote: "MedSim is not a game. It's a space where students think like CEOs. They see how their operations decisions impact finances, how marketing affects stock price. That integrated learning is invaluable.", author: "Cristina García Valverde", role: "ACCOUNT EXECUTIVE" },
      ],
    },
    metrics: {
      items: [
        { value: 95, label: "Crisis Management & Resilience" },
        { value: 92, label: "Integrated Strategic Vision" },
        { value: 98, label: "Knowledge Retention" },
        { value: 89, label: "Decision-Making Improvement" },
      ],
    },
    cta: {
      h2: "Take management learning to the next level",
      text: "Discover how MedSim transforms executive education. Contact us for a personalized demonstration.",
      button: "Request demo",
    },
    contact: {
      h2: "Contact",
      name: "Name",
      email: "Email",
      message: "Message",
      submit: "Send message",
      success: "Message sent successfully",
      error: "Error sending the message",
      info: "You can also write to us at",
      consent: "I have read and accept the",
      consent_link: "Privacy Policy",
      consent_required: "You must accept the Privacy Policy to send the message",
    },
    cookie: {
      text: "This website uses cookies to improve your experience. By continuing to browse, you accept the use of cookies in accordance with our privacy policy.",
      accept: "Accept",
      reject: "Reject",
    },
    footer: {
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      legal: "Legal Notice",
      cookies: "Cookie Policy",
      accessibility: "Accessibility",
      rights: "All rights reserved.",
    },
    privacy: { title: "Privacy Policy" },
    terms: { title: "Terms of Service" },
  },
  de: {
    nav: { home: "Startseite", contact: "Kontakt", simulator: "Zum Simulator" },
    hero: {
      tagline: "Leiten Sie Ihr Krankenhaus: Bringen Sie die Gesundheit mit MedSim auf höchstes Niveau",
      h1_line1: "Leiten Sie ein Krankenhaus.",
      h1_line2: "Meistern Sie die Strategie.",
      subtitle: "Die immersivste Krankenhausmanagement-Simulation zur Entwicklung strategischer Fähigkeiten in der realen Welt.",
      cta_primary: "Plattform erkunden",
      cta_video: "Video ansehen",
    },
    lab: {
      h2: "Treffen Sie strategische Entscheidungen mit realen Daten",
      text: "MedSim simuliert ein wettbewerbsorientiertes Umfeld, in dem Sie die Rolle des CEO übernehmen. Verwalten Sie Finanzen, Betrieb und Marketing, während Sie Ihre realen KPIs kontrollieren. Alles mit akademischer Strenge und Entscheidungen, die reale Konsequenzen haben.",
    },
    features: {
      h2: "Entscheidungen, die den Unterschied machen",
      intro: "Führen heißt nicht nur wählen. Sich MedSim zu stellen bedeutet, die Komplexität einer realen Organisation in ihren grundlegenden Säulen zu managen: Personalmanagement, Wettbewerbsstrategie, Betrieb und Logistik, Talentmanagement und finanzielle Gesundheit.",
      cards: [
        { title: "Strategische Krankenhaussimulation", desc: "Verwalten Sie Betrieb, Finanzen und Marketing eines Krankenhauses im direkten Wettbewerb mit anderen CEOs. Jede Entscheidung hat reale Konsequenzen." },
        { title: "Reale KPIs und Finanzkennzahlen", desc: "Fühlen Sie den Puls des Marktes: Verfolgen Sie die Entwicklung Ihres Aktienkurses und Ihrer Nettogewinne in Echtzeit." },
        { title: "Entscheidungsfindung unter Druck mit integrierter KI", desc: "Ihr strategischer Copilot: Der integrierte KI-Berater optimiert Ihre Entscheidungsfindung." },
        { title: "Akademisches Management-Labor", desc: "MedSim ist kein Spiel, sondern eine strenge Lernumgebung. Konzipiert für Executive-Trainingsprogramme." },
        { title: "Sofortige Analyse und Feedback", desc: "Visualisieren Sie, wie jede strategische Entscheidung das finanzielle Ergebnis beeinflusst." },
        { title: "Kollaborative Wettbewerbsumgebung", desc: "Treten Sie in Echtzeit gegen andere Teams an und lernen Sie von deren Strategien." },
      ],
    },
    testimonials: {
      h2: "Was die Experten sagen",
      items: [
        { quote: "MedSim hat verändert, wie ich strategisches Management unterrichte. Studenten erleben echte Entscheidungen unter Druck und verstehen in Wochen, was normalerweise ein Semester dauern würde.", author: "Professor Gustavo Bautista", role: "STRATEGIEPROFESSOR, COMPLUTENSE UNIVERSITÄT MADRID" },
        { quote: "Die Plattform bietet akademische Strenge ohne Einbußen beim Engagement. Reale KPIs halten die Studenten auf kohärente strategische Entscheidungen fokussiert.", author: "Soraya Gómez", role: "PROFESSORIN FÜR BERUFSAUSBILDUNG" },
        { quote: "Wir haben MedSim in drei Programmen implementiert. Das Feedback der Studenten bestätigt, dass es das effektivste Management-Labor ist, das wir je verwendet haben.", author: "Daniel Arias Aranda", role: "PROFESSOR FÜR UNTERNEHMENSORGANISATION, UNIVERSITÄT GRANADA" },
        { quote: "MedSim ist kein Spiel. Es ist ein Raum, in dem Studenten wie CEOs denken. Sie sehen, wie ihre Betriebsentscheidungen die Finanzen beeinflussen. Dieses integrierte Lernen ist von unschätzbarem Wert.", author: "Cristina García Valverde", role: "ACCOUNT EXECUTIVE" },
      ],
    },
    metrics: {
      items: [
        { value: 95, label: "Krisenmanagement & Resilienz" },
        { value: 92, label: "Integrierte strategische Vision" },
        { value: 98, label: "Wissenserhaltung" },
        { value: 89, label: "Verbesserung der Entscheidungsfindung" },
      ],
    },
    cta: {
      h2: "Bringen Sie das Management-Lernen auf die nächste Stufe",
      text: "Entdecken Sie, wie MedSim die Führungskräfteausbildung transformiert. Kontaktieren Sie uns für eine persönliche Demonstration.",
      button: "Demo anfordern",
    },
    contact: {
      h2: "Kontakt",
      name: "Name",
      email: "E-Mail",
      message: "Nachricht",
      submit: "Nachricht senden",
      success: "Nachricht erfolgreich gesendet",
      error: "Fehler beim Senden der Nachricht",
      info: "Sie können uns auch schreiben an",
      consent: "Ich habe die",
      consent_link: "Datenschutzrichtlinie",
      consent_required: "Sie müssen die Datenschutzrichtlinie akzeptieren, um die Nachricht zu senden",
    },
    cookie: {
      text: "Diese Website verwendet Cookies, um Ihre Erfahrung zu verbessern. Durch die weitere Nutzung akzeptieren Sie die Verwendung von Cookies gemäß unserer Datenschutzrichtlinie.",
      accept: "Akzeptieren",
      reject: "Ablehnen",
    },
    footer: {
      privacy: "Datenschutzrichtlinie",
      terms: "Nutzungsbedingungen",
      legal: "Impressum",
      cookies: "Cookie-Richtlinie",
      accessibility: "Barrierefreiheit",
      rights: "Alle Rechte vorbehalten.",
    },
    privacy: { title: "Datenschutzrichtlinie" },
    terms: { title: "Nutzungsbedingungen" },
  },
};

export default translations;
